import { createAction } from 'typesafe-actions';
import { PopupOrderItem } from '../../types/state/ui/PopupOrderState';

const init = createAction('ui/popup-order/INIT', 
    resolve => (order: PopupOrderItem[]) => resolve({ order }));
const markAsShown = createAction('ui/popup-order/MARK_SHOWN');

export const popupOrderActions = {
    init,
    markAsShown
}
